import React from "react";

// Minimalist AG monogram — luxury financial mark
export const LogoMark = ({ size = 36, gold = "#D4AF37" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="logo-mark-svg"
    aria-label="ASHIR GROUP"
  >
    {/* outer thin frame */}
    <rect x="1" y="1" width="62" height="62" rx="2" stroke={gold} strokeWidth="0.8" opacity="0.55" />
    {/* inner corner ticks */}
    <path d="M6 6 L12 6 M6 6 L6 12" stroke={gold} strokeWidth="0.8" />
    <path d="M58 6 L52 6 M58 6 L58 12" stroke={gold} strokeWidth="0.8" />
    <path d="M6 58 L12 58 M6 58 L6 52" stroke={gold} strokeWidth="0.8" />
    <path d="M58 58 L52 58 M58 58 L58 52" stroke={gold} strokeWidth="0.8" />
    {/* "A" stroke */}
    <path d="M16 46 L28 18 L40 46" stroke={gold} strokeWidth="1.4" strokeLinejoin="miter" />
    <path d="M21 38 L35 38" stroke={gold} strokeWidth="1.2" />
    {/* "G" arc fused into A's right diagonal */}
    <path
      d="M48 30 a10 10 0 1 0 -2 14 L48 44 L48 36 L42 36"
      stroke={gold}
      strokeWidth="1.4"
      strokeLinecap="square"
      fill="none"
    />
  </svg>
);

export const LogoHorizontal = ({ gold = "#D4AF37", muted = "#A3ABB8" }) => (
  <div className="flex items-center gap-3" data-testid="logo-horizontal">
    <LogoMark size={34} gold={gold} />
    <div className="leading-none">
      <div
        className="font-serif-ag text-white"
        style={{ fontSize: "1.05rem", letterSpacing: "0.32em", fontWeight: 500 }}
      >
        ASHIR
      </div>
      <div
        className="font-sans-ag"
        style={{ fontSize: "0.62rem", letterSpacing: "0.45em", color: muted, marginTop: 3 }}
      >
        GROUP
      </div>
    </div>
  </div>
);
